import { render } from "./EditRestaurantModal.vue?vue&type=template&id=a96f1bb4&scoped=true"
import script from "./EditRestaurantModal.vue?vue&type=script&lang=js"
export * from "./EditRestaurantModal.vue?vue&type=script&lang=js"

import "./EditRestaurantModal.vue?vue&type=style&index=0&id=a96f1bb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a96f1bb4"]])

export default __exports__